import React from "react";

import { Props } from "./types";
import { DefaultIcon } from "./defaultIcon";
import styles from "./styles.scss";

function Link({ link }: Props) {
  const [hasLoadFailed, setHasLoadFailed] = React.useState(false);
  const maxLength: number = 9;

  return (
    <a href={link.url} target="_blank" className={styles.link}>
      {link.icon && !hasLoadFailed ? (
        <img
          className={styles.icon}
          src={link.icon}
          alt={link.name}
          onError={() => setHasLoadFailed(true)}
        />
      ) : (
        <DefaultIcon className={styles.icon} />
      )}
      <span className={styles.name}>
        {link.name.length >= maxLength
          ? `${link.name.slice(0, maxLength)}...`
          : link.name}
      </span>
    </a>
  );
}

export { Link };
